import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDailyChallenge } from '../hooks/useDailyChallenge';
import DailyStreakBanner from './DailyStreakBanner';

const DailyChallengeCard: React.FC = () => {
  const { isCompleted, loginStreak } = useDailyChallenge();
  const navigate = useNavigate();

  return (
    <div className="daily-challenge-section">
      <DailyStreakBanner streak={loginStreak.currentStreak} />
      <div className="daily-challenge-card">
        <div className="daily-challenge-info">
          <h3 className="daily-challenge-title">Today's Challenge</h3>
          <p className="daily-challenge-desc">
            {isCompleted
              ? 'Completed! Come back tomorrow for a new challenge.'
              : '10 curated questions — test your knowledge daily!'}
          </p>
        </div>
        <div className="daily-challenge-action">
          {isCompleted ? (
            <span className="daily-check" aria-label="Completed">&#10003;</span>
          ) : (
            <button
              className="daily-play-btn"
              onClick={() => navigate('/daily')}
            >
              Play
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailyChallengeCard;
